export class BalanceAccountChart {
  constructor(
    public accountType: string,
    public date: string | Date,
    public balance: number,
    public percentage: number
  ) {}
}
